var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardTiles',{attrs:{"tiles":_vm.filteredTiles,"currentUser":_vm.getCurrentUser,"currentCompany":_vm.getUserCompany}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }